module.exports = __webpack_public_path__ + "static/media/details1.5c61cd9a.svg";